module.exports = __webpack_public_path__ + "static/media/pc_bg.a3ea0532.png";